import React from "react";
import {
  Button,
  Tooltip,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
  Box,
} from "@chakra-ui/react";
import {
  FaBars,
  FaBitcoin,
  FaBook,
  FaEdit,
  FaQrcode,
  FaTrash,
  FaWifi,
  FaClock,
  FaMoneyBillWave,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import moment from "moment";

// Componente para os itens do menu com estilo de hover consistente
const MenuItemFlex = ({ icon, text, color, onClick, marginTop, children }) => {
  return (
    <Flex
      gap="10px"
      marginTop={marginTop || "0px"}
      color={color || "inherit"}
      onClick={onClick}
      _hover={{ 
        backgroundColor: "whiteAlpha.200", 
        borderRadius: "4px", 
        cursor: "pointer" 
      }}
      padding="5px"
      alignItems="center"
    >
      {icon}
      {children || <span>{text}</span>}
    </Flex>
  );
};

/**
 * Componente de tabela para exibir os módulos com filtragem e ações
 */
const ModulesTable = ({
  modules = [],
  setSelectedId,
  setSelectedMaquina,
  setModuleProps,
  onOpenDeleteModal,
  onOpenRemoteCreditModal,
  onOpenModalRelatorio,
  onOpenBonusPaymentModal,
  onOpenTimerConfigModal,
  onOpenEditModal,
  tabType
}) => {
  const toast = useToast();

  // Renderiza a tabela dos módulos com base no tipo de aba
  const renderTable = () => {
    return (
      <TableContainer minH="500px">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th borderColor="#1F2630"></Th>
              <Th borderColor="#1F2630">Nome</Th>
              <Th borderColor="#1F2630">Admin pos</Th>
              <Th borderColor="#1F2630">Conexão</Th>
              <Th borderColor="#1F2630">Loja</Th>
              <Th borderColor="#1F2630">Estoque</Th>
              <Th borderColor="#1F2630">Último Pagamento</Th>
              <Th borderColor="#1F2630">Maquininha Serial</Th>
              <Th borderColor="#1F2630">Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {modules.map(
              ({
                id,
                nome,
                descricao,
                estoque,
                pessoaId,
                ultimoPagamentoRecebido,
                status,
                store_id,
                maquininha_serial,
                pos,
              }) => (
                <Tr key={id}>
                  <Td borderColor="#1F2630">
                    <Popover placement="bottom-end">
                      <PopoverTrigger>
                        <Button
                          backgroundColor="transparent"
                          _active={{ backgroundColor: "transparent" }}
                          _hover={{ backgroundColor: "transparent" }}
                        >
                          <FaBars color="white" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent maxW="180px">
                        <PopoverArrow />
                        <PopoverBody>
                          <MenuItemFlex
                            icon={<FaEdit />}
                            text="Editar"
                            onClick={() => {
                              setModuleProps({
                                id,
                                nome,
                                descricao,
                                estoque,
                                store_id,
                                maquininha_serial,
                                pos
                              });
                              onOpenEditModal();
                            }}
                          />
                          <MenuItemFlex
                            icon={<FaBitcoin />}
                            text="Crédito Remoto"
                            marginTop="10px"
                            onClick={() => {
                              setSelectedId(id);
                              onOpenRemoteCreditModal();
                            }}
                          />
                          <MenuItemFlex
                            icon={<FaMoneyBillWave />}
                            text="Config. Bônus"
                            marginTop="10px"
                            onClick={() => {
                              setSelectedId(id);
                              setSelectedMaquina({ nome, id });
                              onOpenBonusPaymentModal();
                            }}
                          />
                          <MenuItemFlex
                            icon={<FaClock />}
                            text="Config. Tempo"
                            marginTop="10px"
                            onClick={() => {
                              setSelectedId(id);
                              setSelectedMaquina({ nome, id });
                              onOpenTimerConfigModal();
                            }}
                          />
                          <MenuItemFlex
                            icon={<FaQrcode />}
                            marginTop="10px"
                          >
                            <Link
                              target="_blank"
                              to={`//www.mercadopago.com.br/stores/detail?store_id=${store_id}`}
                              style={{
                                display: "block",
                                width: "100%"
                              }}
                            >
                              Integrar MP
                            </Link>
                          </MenuItemFlex>
                          <MenuItemFlex
                            icon={<FaBook />}
                            text="Relatório"
                            marginTop="10px"
                            onClick={() => {
                              setSelectedId(id);
                              setSelectedMaquina({ nome, id });
                              onOpenModalRelatorio();
                            }}
                          />
                          <MenuItemFlex
                            icon={<FaTrash />}
                            text="Excluir"
                            marginTop="10px"
                            color="red"
                            onClick={() => {
                              setSelectedId(id);
                              onOpenDeleteModal();
                            }}
                          />
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {nome}
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {tabType !== "allModules" && pessoaId ? (
                      <Tooltip label="Clique para copiar" hasArrow>
                        <Button
                          variant="ghost"
                          size="sm"
                          color="white"
                          _hover={{ bg: "whiteAlpha.200" }}
                          _active={{ bg: "whiteAlpha.300" }}
                          onClick={() => {
                            navigator.clipboard.writeText(pessoaId);
                            toast({
                              title: "ID copiado!",
                              status: "success",
                              duration: 2000,
                              isClosable: true,
                            });
                          }}
                        >
                          {pos}
                        </Button>
                      </Tooltip>
                    ) : (
                      pos
                    )}
                  </Td>
                  <Td borderColor="#1F2630">
                    <FaWifi
                      color={status ? (status === "OFFLINE" ? "red" : "green") : "red"}
                    />
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {descricao}
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {estoque}
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {moment(ultimoPagamentoRecebido).format("DD/MM/YYYY")}
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {maquininha_serial}
                  </Td>
                  <Td color="white" borderColor="#1F2630">
                    {status}
                  </Td>
                </Tr>
              )
            )}
          </Tbody>
        </Table>
      </TableContainer>
    );
  };

  return renderTable();
};

export default ModulesTable;